<template> 
    <span>
        <InputFile v-bind:is-error="isError" v-bind:title="label" v-bind:onload="fileOnLoad" ref="inputFile" v-model="value"/>  
    </span>
</template>
<script>
    //https://github.com/yorkbc2/vue-impot-xlsx
    import store from '@/store';
	import InputFile from "@/components/common/file/InputFile.vue"
	import XLSX from "xlsx"
	import {calculateFileSize, readDataFromFile} from "@/components/common/file/fileModule.js"
	import {parseXLSJSONToObject} from "@/components/common/file/xlsxModule.js"
    export default {
        components: {
            InputFile
        },
        data(){
            return {
				label: "",
				labels: {
					startLabel: "把文件拖到这里，或者点击选择。",
					successLabel: '文件是 - "?"',
					sizeError: "最大允许一个?MB文件，选择另一个文件。",
					extensionError: '不允许的文件类型: "?", 选择另一个文件。'
				},
				isError: false
            }
        },
        props: {
            maxFileSizeMB: null,
            value: null,
            headerMap: null,
        },
        watch: {
            value: {
                handler(newValue, oldValue) {
                    if(newValue == null){
                        this.label = this.labels.startLabel;  
                    }
                },
                deep: true
            }
        },
        mounted(){
            this.label = this.labels.startLabel;
        },
        created(){        
        },
        methods: {			
            /**
            * @param {Event} event Событие, которое передает onChange
            */
            fileOnLoad(event) {
                var that = this; 
                that.$emit("input", null);
                that.$emit("change", null); 
                this.label = this.labels.startLabel;                
                // Берем файл, который загрузил клиент
                let uploadedFile = event.target.files[0];
                // Размер файла в МБ
                let size = calculateFileSize(uploadedFile.size);
                if (size > (this.maxFileSizeMB?this.maxFileSizeMB:10)) {
                    this.toggleIsError(true)
                    this.label = this.labels.sizeError.replace('?', this.maxFileSizeMB?this.maxFileSizeMB:10);
                    return false;
                }
                // Розрываем название файла, чтобы получить его расширение
                let splittedName = uploadedFile.name.split('.'),
                    // Получаем последний элемент массива
                    splittedNameLastElement = splittedName[splittedName.length - 1];
                // Проверяем расширение файла
                if (splittedNameLastElement !== 'xls' && splittedNameLastElement !== 'xlsx') {
                    this.toggleIsError(true)
                    // Ошибка об неправильном расширении файла
                    this.label = this.labels.extensionError
                                        .replace('?', '.' + splittedNameLastElement.toLowerCase())
                    return false;
                }
                this.toggleIsError(false)
                // Оповещение об успешной валидации файла
                this.label = this.labels.successLabel.replace("?", uploadedFile.name);
                // Прочитка файла с помощью функции с модуля fileModule
                readDataFromFile(uploadedFile).then((response /*:object*/) => {
                    // Читаем данные, которые хранятся в файле
                    let xlsxData = XLSX.read(response, {type: 'binary'});
                    // Парсим в JSON формат
                    let xlsxDataJSON = XLSX.utils.sheet_to_json(xlsxData.Sheets[xlsxData.SheetNames[0]], {header: 1});
                    // Парсим JSON в тот формат, который нам нужен
                    let parsedData = parseXLSJSONToObject(xlsxDataJSON, that.headerMap);
                    that.$emit("input", parsedData);
                    that.$emit("change", parsedData);   
                })
            },
			// Изменяет значение свойства isError на указаное
			/**
			* @param {boolean} isError
			*/
			toggleIsError(isError) {
			    this.isError = isError || false;
			} 
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/common/selector/file/selectorExcel.vue